module.exports = __webpack_public_path__ + "img/zfcg_06.7826e63c.png";